class Inputs {

	constructor() {
		this.buildCheckboxes();
		this.buildRadios();
		this.buildSelects();
	}

	buildCheckboxes() {
		document.querySelectorAll(".custom-checkboxes-container").forEach(container => {
			container.selectionCount = 0;
			container.max = container.dataset.max || 2;
			const checkboxes = container.querySelectorAll(".input-checkbox");
			checkboxes.forEach(checkbox => {
				checkbox.addEventListener("click", () => {
					if (checkbox.classList.contains("selected")) {
						checkbox.classList.remove("selected");
						container.selectionCount--;
						container.classList.remove("max-selection-count");
					} else {
						if (container.selectionCount === (container.max - 1)) {
							container.classList.add("max-selection-count");
						}
						if (container.selectionCount < container.max) {
							checkbox.classList.add("selected");
							container.selectionCount++;
						}
					}
				});
			});
		});
	}

	buildRadios() {
		document.querySelectorAll(".custom-radio-container").forEach(container => {
			const radios = container.querySelectorAll(".input-radio");
			radios.forEach(radio => {
				radio.addEventListener("click", () => {
					radios.forEach(toDeselect => {
						toDeselect.classList.remove("selected");
					});
					radio.classList.add("selected");
				});
			});
		});
	}

	buildSelects() {
		this.selects = document.querySelectorAll(".custom-select");
		if (this.selects.length) {
			this.selects.forEach(select => {
				const button = select.querySelector(".btn");
				button.addEventListener("click", () => {
					select.classList.add("open");
				});

				const values = select.querySelectorAll(".select-values .value");
				values.forEach(elem => {
					elem.addEventListener("click", () => {
						button.innerHTML = elem.innerHTML;
						values.forEach(toDeselect => {
							toDeselect.classList.remove("selected");
						});
						elem.classList.add("selected");
						select.classList.remove("open");
						const event = new CustomEvent("customselect", {detail: elem.dataset.value});
						select.dispatchEvent(event);
					});
				});
			});

			document.addEventListener("click", e => {
				if (!e.target.closest(".custom-select")) {
					this.selects.forEach(select => {
						select.classList.remove("open");
					});
				}
			});
		}
	}
}
